import { createStore, applyMiddleware, compose } from "redux";
import { history, routerMiddleware } from "../utils/navigation";
import { createMigrate, persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // default: localStorage if web, AsyncStorage if react-native
// import immutableTransform from "redux-persist-transform-immutable"; // Removed package
import { reducers } from "../reducers";
import { run } from "@cycle/run";
import { makeHTTPDriver } from "@cycle/http";
import { createCycleMiddleware } from "redux-cycles";
import { migrations } from "./migrations";
import main from "../cycles/cycles";
import { createLogger } from "redux-logger";
// import Immutable from "immutable"; // Removed - no longer using Immutable.js
import { FRONTEND_URL } from "../config/index";
import { createStateSyncMiddleware } from "redux-state-sync";
import { TRYOUT_SET_AUTH_CODE } from "../actions/types";
import packageJson from "../../package.json";
const middleWare = [];

middleWare.push(routerMiddleware(history));

const config = {
  transforms: [],
  key: "rootNbgDeveloper",
  whitelist: ["applicationUser", "tryout", "cookies", "headerPin"],
  version: packageJson.persistVersion,
  migrate: createMigrate(migrations),
  storage,
};

const cycleMiddleware = createCycleMiddleware();
const { makeActionDriver, makeStateDriver } = cycleMiddleware;

middleWare.push(cycleMiddleware);

if (process.env.NODE_ENV === `development`) {
  let logger;

  logger = createLogger({
    stateTransformer: (state) => state, // State is already plain JS objects
  });

  middleWare.push(logger);
}

middleWare.push(
  createStateSyncMiddleware({
    predicate: (action) => action.type === TRYOUT_SET_AUTH_CODE,
  })
);

const store = createStore(
  persistReducer(config, reducers),
  compose(applyMiddleware(...middleWare))
);

export const persistor = persistStore(store);

// Re-export history for backward compatibility
export { history };

run(main, {
  ACTION: makeActionDriver(),
  STATE: makeStateDriver(),
  HTTP: makeHTTPDriver(),
});

export default store;
